import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          影片导览
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按类型快速浏览电影大全片库，找到你想看的每部电影
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-4 md:p-5 rounded-lg border border-background-300/40 bg-background-100/60 transition-all duration-200 hover:border-primary-500/30 hover:bg-background-100 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-500/10 flex items-center justify-center shrink-0 transition-colors group-hover:bg-primary-500/20">
                <i className={`${item.icon} text-primary-400 text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800">
                    {item.title}
                  </h3>
                  <span className="text-xs font-medium text-accent-400 whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}